module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_round__oval_vector.c20e4c23.svg";